import { formatDeviation } from '#utils/formatDeviation.ts';

type DeviationValueProps = {
    targetQuantity: number;
    actualQuantity: number | undefined;
    emptyPlaceholder?: string;
    unit?: string;
};

export const DeviationValue = ({
    targetQuantity,
    actualQuantity,
    emptyPlaceholder = '-',
    unit,
}: DeviationValueProps) => {
    const actualValue = actualQuantity !== undefined ? `${actualQuantity}${unit ? ` ${unit}` : ''}` : emptyPlaceholder;
    const deviationValue = formatDeviation(targetQuantity, actualQuantity, emptyPlaceholder);
    const formattedDeviationValue =
        deviationValue !== emptyPlaceholder && unit ? `${deviationValue} ${unit}` : deviationValue;

    return (
        <div className='display-flex gap-10'>
            <span>{actualValue}</span>
            <span>
                <span className='label label-condensed label-danger border-none margin-top--1'>
                    {formattedDeviationValue}
                </span>
            </span>
        </div>
    );
};
